import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbService, BreadcrumbItem } from '@shared/services/breadcrumb.service';
import { MatIcon } from '@angular/material/icon';
import { Subject, takeUntil } from 'rxjs';
import { filter } from 'rxjs/operators';
import { NavigationEnd } from '@angular/router';

@Component({
  selector: 'ui-organism-main-title',
  standalone: true,
  imports: [CommonModule, MatIcon],
  templateUrl: './ui-organism-main-title.component.html',
  styleUrl: './ui-organism-main-title.component.scss',
})
export class UiOrganismMainTitleComponent implements OnInit, OnDestroy {
  @Input() text = ''; // Mantener compatibilidad con uso existente
  @Input() showBreadcrumb = true; // Permitir desactivar breadcrumb si se necesita

  breadcrumbs: BreadcrumbItem[] = [];
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private breadcrumbService: BreadcrumbService,
  ) {}

  ngOnInit(): void {
    // Si hay texto específico, usar modo tradicional (compatibilidad)
    if (this.text) {
      this.showBreadcrumb = false;
      return;
    }

    // Modo breadcrumb - actualizar solo cuando termina la navegación
    this.updateBreadcrumbs();
    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      )
      .subscribe(() => {
        this.updateBreadcrumbs();
      });

    // También actualizar cuando se invalida el caché
    this.breadcrumbService.cacheInvalidated.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.updateBreadcrumbs();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private async updateBreadcrumbs(): Promise<void> {
    this.breadcrumbs = await this.breadcrumbService.getBreadcrumbs();
  }

  navigateTo(event: Event, item: BreadcrumbItem): void {
    event.preventDefault(); // Prevenir navegación del navegador
    if (item.url && !item.isLast) {
      this.router.navigate([item.url]);
    }
  }
}
